import React, { useState, useEffect } from 'react'
import MainLayout from '../layout/MainLayout'
import DocumentTile from '../components/DocumentTile';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

function DocumentList(props) {



    const [searchParams] = useSearchParams();
    const currentPageNo = Number(searchParams.get('page') ? searchParams.get('page') : "0");

    const collectionId = searchParams.get('collectionIds');
    const collectionIdArr = (collectionId ? collectionId.split(',').map(Number) : [0, 1, 2, 3, 4, 5, 6].map(Number));

    const categoryId = searchParams.get('categoryIds');
    const categoryIdArr = categoryId ? categoryId.split(',').map(Number) : [1, 2, 3, 4, 5, 6].map(Number);

    const [maxPage, setMaxPage] = useState();
    const [previousPageNo, setPreviousPageNo] = useState();
    const [nextPageNo, setNextPageNo] = useState();

    const setPages = () => {
        setPreviousPageNo(currentPageNo - 1);
        setNextPageNo(currentPageNo + 1);
    }

    const [showFilters, setShowFilters] = useState(false);
    const toggleShowFilters = () => {
        setShowFilters(!showFilters);
    }


    const [filterCollections, setFilterCollections] = useState([]);
    const toggleCollectionSelection = (e, id) => {
        let tmp = filterCollections;
        if (tmp.includes(id)) {
            tmp.pop(id);
        } else {
            tmp.push(id);
        }
        setFilterCollections(tmp);
    }

    const [filterCategories, setFilterCategories] = useState([]);
    const toggleCategorySelection = (e, id) => {
        let tmp = filterCategories;
        if (tmp.includes(id)) {
            tmp.pop(id);
        } else {
            tmp.push(id);
        }
        setFilterCategories(tmp);
    }

    const { metaNumber, signatory } = useParams();

    const [documentList, setDocuments] = useState([]);
    const getCollectionDocuments = async () => {
        let url = "/api/v1/documents/get?docType=" + collectionId
            + "&metaNumber=" + metaNumber
            + (categoryId ? '&category=' + categoryId : '')
            + "&pageNo=" + currentPageNo;
        axios
            .get(url)
            .then((result) => {
                setDocuments(result.data.documents);
                setMaxPage(result.data.numberOfPages);
            })
            .catch((err) => console.log(err));
    };



    const [collections, setCollections] = useState([]);
    const getCollections = async () => {
        axios
            .get("/api/v1/collections/group/1")
            .then((result) => {
                setCollections(result.data);
            }).catch((err) => console.log(err));
    }

    const [categories, setCategories] = useState([]);
    const getCategories = async () => {
        axios
            .get("/api/v1/categories")
            .then((results) => {
                setCategories(results.data);
            }).catch((err) => console.log(err));
    }


    const unmakeUrlName = (str) => {
        return str.replaceAll("-", " ");
    }

    const applyFilter = () => {
        let andFlag = false;

        let url = '?';
        let tmp = '';
        if (filterCollections.length > 0) {
            filterCollections.map((id, idx) => {
                tmp = tmp + id;
                if (idx + 1 != filterCollections.length) {
                    tmp = tmp + ',';
                }
            })
            andFlag = true;
        } else {
            tmp = tmp + "0,1,2,3,4,5,6";
        }
        url = url + 'collectionIds=' + tmp;
        if (filterCategories.length > 0) {
            tmp = '';
            filterCategories.map((id, idx) => {
                tmp = tmp + id;
                if (idx + 1 != filterCategories.length) {
                    tmp = tmp + ',';
                }
            })
            if (andFlag) {
                url = url + '&';
            }
            andFlag = true;
            url = url + 'categoryIds=' + tmp;
        }

        window.location.href = url;

    }

    useEffect(() => {
        setPages();
        getCollectionDocuments();
        getCollections();
        getCategories();
        setFilterCollections(collectionIdArr);
        setFilterCategories(categoryIdArr);
    }, []);

    return (
        <div>
            <MainLayout>
                <title>Executive Actions</title>
                <div>
                    <Link to="/ExecutiveOrders.html">Back to List</Link>
                </div>
                <h1>#{metaNumber} {unmakeUrlName(signatory)}</h1>
                <div className="boxed-area">
                    <div className="nav-bar">
                        <div className="nav-left"></div>

                        <div className="nav-right">
                            <button
                                className={`toggle-button ${showFilters ? 'active' : ''}`}
                                onClick={() => toggleShowFilters()}>
                                <img alt="Filter" src="/graphics/icons/filter.svg" /> Filter
                            </button>
                        </div>

                    </div>
                    {showFilters && (
                        <div className="filter-container">
                            <div className="filter-column">
                                <b>Filter by</b>
                                {collections.map((collection, index) => (
                                    <div key={collection.id}>
                                        <input type="checkbox" name={collection.name} defaultChecked={filterCollections.includes(collection.id)} onChange={e => toggleCollectionSelection(e, collection.id)} /> {collection.name}
                                    </div>
                                ))}
                            </div>
                            <div className="filter-column">
                                <b>Categories</b>
                                {categories.map((category, index) => (
                                    <div key={category.categoryId}>
                                        <input type="checkbox" name={category.name} defaultChecked={filterCategories.includes(category.categoryId)} onChange={(e) => toggleCategorySelection(e, category.categoryId)} /> {category.name}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    {showFilters && (
                        <button style={{ margin: "0 0 20px 20px" }} onClick={() => applyFilter()} >Apply Filters</button>
                    )}

                </div>
                <h3>{documentList.length} documents (Page {currentPageNo + 1} of {maxPage})</h3>

                {
                    documentList.map((pDoc, index) => (
                        <DocumentTile key={pDoc.documentId} {...pDoc}></DocumentTile>
                    ))
                }

                <br />
                <center>

                    <a href={"/Presidents/" + metaNumber + "/" + signatory + "?collectionIds=" + collectionId
                        + (categoryId ? "&categoryIds=" + categoryId : "")
                        + "&page=" + previousPageNo}>
                        {currentPageNo > 0 ? "Prev Page" : ""}
                    </a>
                    &nbsp;&nbsp;
                    Page {currentPageNo + 1} of {maxPage}
                    &nbsp;&nbsp;
                    <a href={"/Presidents/" + metaNumber + "/" + signatory + "?collectionIds=" + collectionId
                        + (categoryId ? "&categoryIds=" + categoryId : "")
                        + "&page=" + nextPageNo}>
                        {nextPageNo < maxPage ? "Next Page" : ""}

                    </a>
                </center>

            </MainLayout >
        </div >
    )
}

export default DocumentList
